/**
 * Shared workspace icon glyphs from registry icon keys.
 * Do not hardcode icons in pages — use registry.icon + WorkspaceIcon.
 */
import React from "react";

const PATHS = {
  user: "M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0 2c-4 0-8 2-8 4v2h16v-2c0-2-4-4-8-4z",
  creator:
    "M12 3l2.1 4.3 4.7.7-3.4 3.3.8 4.7L12 13.8 7.8 16l.8-4.7L5.2 8l4.7-.7L12 3z",
  org: "M4 20V8l8-4 8 4v12H4zm4-2h4v-4H8v4zm6 0h4v-6h-4v6z",
  project: "M3 5h18v4H3V5zm0 6h12v4H3v-4zm0 6h18v2H3v-2z",
  sales: "M4 18V6h2v12H4zm4-8h12v2H8V10zm0 4h8v2H8v-2zm0-8h12v2H8V6z",
  shield:
    "M12 2l8 3v6c0 5-3.4 9.4-8 11-4.6-1.6-8-6-8-11V5l8-3z",
  admin: "M4 4h7v7H4V4zm9 0h7v7h-7V4zM4 13h7v7H4v-7zm9 3h7v4h-7v-4z",
  home: "M4 11l8-7 8 7v9H4v-9z",
  dot: "M12 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4z",
};

export function WorkspaceIcon({ name, className, title }) {
  const d = PATHS[name] || PATHS.dot;
  return (
    <svg
      className={className || "ws-icon"}
      viewBox="0 0 24 24"
      width="16"
      height="16"
      aria-hidden={title ? undefined : true}
      role={title ? "img" : "presentation"}
    >
      {title ? <title>{title}</title> : null}
      <path fill="currentColor" d={d} />
    </svg>
  );
}

export default WorkspaceIcon;
